export const font = {
  family: {
    sans: `'Roboto', sans-serif`,
    mono: `'Roboto Mono', monospace`,
  },
  size: {
    66: '0.675rem',
    75: '0.75rem',
    88: '0.875rem',
    100: '1rem',
    125: '1.25rem',
    150: '1.5rem',
    175: '1.75rem',
    200: '2rem',
    225: '2.25rem',
    250: '2.5rem',
    266: '2.675rem',
    300: '3rem',
  },
  weight: {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
  letterSpacing: {
    condensed: '-0.025em',
    normal: '0',
    relaxed: '0.025em',
  },
  lineHeight: {
    reset: 1,       // line height reset for components that require precise control over spacing (ex: buttons, inputs)
    compact: 1.2,   // line height for tight vertical spacing (ex: headings)
    normal: 1.4,    // default line height for body text
    relaxed: 1.6,   // line height for more open vertical spacing (ex: lists, forms)
  },
  variant: {
    tabularNums: 'tabular-nums',
    tabularNumsSlashedZero: 'tabular-nums slashed-zero',
  },
};

export default font;